import { BlueCardAdvancementStatus, PendingItemStatus } from '@appTypes/enums';
import { activityTypeIds, advancementStatuses } from '@shared/constants';
import { newPermissions } from '@shared/newPermissions';

export { youthProfileModuleName as moduleName } from '@shared/constants';

export const GET_YOUTH_REQUIREMENTS_AFTER_EDIT_ERROR =
  'GET_YOUTH_REQUIREMENTS_AFTER_EDIT_ERROR';

export const advancementsStates = Object.freeze({
  PREVIOUS: 'previous',
  LAST_APPROVED: 'lastApproved',
  NEXT: 'next',
});

export const youthProfileTabs = Object.freeze({
  PENDING: 'pending',
  STARTED: 'started',
  APPROVED: 'approved',
  INFORMATION: 'information',
});

export const formItemLayout = Object.freeze({
  labelCol: {
    span: 24,
  },
  wrapperCol: {
    span: 24,
  },
});

export const sortAdvancementTypes = Object.freeze({
  MERIT_BADGES: 'meritBadges',
  RANKS: 'ranks',
  AWARDS: 'awards',
  ADVENTURES: 'adventures',
  SSELECTIVES: 'ssElectives',
});

export const advancementSorters = Object.freeze({
  ALPHA: 'alphabetical',
  ALPHA_DESC: 'alphabeticalDesc',
  DATE_EARNED: 'dateEarned',
  DATE_EARNED_DESC: 'dateEarnedDesc',
  DATE_APPROVED: 'dateApproved',
});

export enum advancementFilters {
  ALL = 'showAll',
  ALL_SSELECTIVES = 'allSSElectives',
  APPROVED = 'approved',
  STARTED = 'started',
  NOT_STARTED = 'notStarted',
  COMPLETED = 'completed',
}

// See SBL-6323
export enum NewAdvancementFilter {
  ALL = 'showAll',
  APPROVED = 'approved',
  APPROVED_COMPLETED = 'approvedCompleted',
  COMPLETED = 'completed',
  STARTED = 'started',
  NOT_STARTED = 'notStarted',
  /** Only for SS Electives */
  ALL_SSELECTIVES = 'allSSElectives',
}

export enum advRequirementOperations {
  APPROVE = 'approve',
  COMPLETE = 'complete',
  UNAPPROVE = 'unapprove',
}

export const activityTypeIdsToSummaryKey = Object.freeze({
  [activityTypeIds.SERVICE_PROJECTS]: 'serviceLogs',
  [activityTypeIds.CAMPOUTS]: 'campingLogs',
  [activityTypeIds.HIKES]: 'hikingLogs',
  [activityTypeIds.LONG_CRUISE]: 'longCruiseLogs',
});

export const summaryKeyToValueKey = Object.freeze({
  serviceLogs: 'totalNumberOfHours',
  campingLogs: 'totalNumberOfNights',
  hikingLogs: 'totalNumberOfMiles',
  longCruiseLogs: 'totalNumberOfDays',
});

export const cubScouts2024RankVersionsIds = Object.freeze([
  100, 101, 102, 103, 104, 105,
]);

export const trainingProgram = Object.freeze({
  YPT: 'profile.ProfileInfo.ypt',
  SYT: 'profile.ProfileInfo.syt',
});

export const maxAdvancementsComments = 50;

export const youthEditApprovePermissions: string[] = [
  newPermissions.EDIT_APPROVE_SCOUT,
  newPermissions.EDIT_APPROVE_FIRST_CLASS,
  newPermissions.EDIT_APPROVE_SECOND_CLASS,
  newPermissions.EDIT_APPROVE_TENDERFOOT,
];

export const mbStatusToBlueCardStatus: Record<
  string,
  BlueCardAdvancementStatus
> = {
  [advancementStatuses.STARTED]: BlueCardAdvancementStatus.STARTED,
  leaderSigned: BlueCardAdvancementStatus.LEADER_SIGNED,
  [advancementStatuses.COMPLETED]: BlueCardAdvancementStatus.COMPLETED,
  [advancementStatuses.COUNSELOR_APPROVED]:
    BlueCardAdvancementStatus.COUNSELOR_APPROVED,
  [advancementStatuses.APPROVED]: BlueCardAdvancementStatus.LEADER_APPROVED,
  [advancementStatuses.AWARDED]: BlueCardAdvancementStatus.AWARDED,
  [PendingItemStatus.STARTED]: BlueCardAdvancementStatus.STARTED,
  [PendingItemStatus.LEADER_SIGNED]: BlueCardAdvancementStatus.LEADER_SIGNED,
  [PendingItemStatus.COUNSELOR_APPROVED]:
    BlueCardAdvancementStatus.COUNSELOR_APPROVED,
  [PendingItemStatus.LEADER_APPROVED]:
    BlueCardAdvancementStatus.LEADER_APPROVED,
  [PendingItemStatus.COMPLETED]: BlueCardAdvancementStatus.COMPLETED,
  [PendingItemStatus.AWARDED]: BlueCardAdvancementStatus.AWARDED,
};

export enum expectedErrorDesc {
  NOT_BELONG_ORG = 'Purchase order does not belong to the organization.',
}

export enum statusesSYT {
  ACTIVE = 'active',
  EXPIRED = 'expired',
}

export const awardParentRequirementWithLinkMBChildren = Object.freeze([
  766, 2591, 2594, 2597, 3493, 5172, 5228, 5231, 5233, 5256, 5257, 5300, 5301,
  5344, 5345,
]);

export const awardparentRequirementWithLinkRankChildren = Object.freeze([
  763, 775, 781, 795, 814, 822, 1475, 5247, 5299, 5343,
]);

export const awardRequirementWithLinkRankChildren = Object.freeze([
  5146, 5147, 5188, 5189, 5191, 5192, 5194, 5195, 5211, 5212, 5214, 5215, 5223,
  5224, 5510, 5532, 5554,
]);
